import ko from "knockout";
import register from "flow/knockout/register";

type ValidationInfo = { hasError: boolean; validationMessage: string };

interface IValidationObservable extends KnockoutObservable<any> {
    hasError: KnockoutObservable<boolean>;
    validationMessage: KnockoutObservable<string>;
}

register.registerKnockoutExtension(
    "lcvalidate",
    function (target: IValidationObservable, validateFunction: (data: any) => ValidationInfo) {
        //add some sub-observables to our observable
        target.hasError = ko.observable();
        target.validationMessage = ko.observable();

        //define a function wrapper to call validation function
        ko.computed(function () {
            const result = validateFunction(target());

            target.hasError(result.hasError);
            target.validationMessage(result.validationMessage);
        });

        //return the original observable
        return target;
    }
);
